export function isViewingForSSRSnapshot() {
  return (
    typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap"
  );
}
